import Small from 'UIComponents/elements/Small';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import UIRibbon from 'UIComponents/ribbon/UIRibbon';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UILockBadge from 'UIComponents/badge/UILockBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { H7 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TriggerTypeButton = ({
  illustrationName,
  disabled,
  tooltip,
  title,
  info,
  badgeType,
  onClick,
  locked,
  upgradePoint,
  selected
}) => {
  const hasUpgradeModal = !!locked && !!upgradePoint;
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradePoint, hasUpgradeModal);
  return /*#__PURE__*/_jsxs(UICardWrapper, {
    "data-test-id": "trigger-type-button",
    className: "m-y-4 m-left-0 m-right-6",
    children: [badgeType === 'NEW' && /*#__PURE__*/_jsx(UIRibbon, {
      use: "new",
      position: "left",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.enrollSelection.newBadge"
      })
    }), badgeType === 'BETA' && /*#__PURE__*/_jsx(UIRibbon, {
      use: "beta",
      position: "left",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.enrollSelection.betaBadge"
      })
    }), /*#__PURE__*/_jsx(UITooltip, {
      disabled: !tooltip,
      title: tooltip,
      placement: "right",
      children: /*#__PURE__*/_jsxs(UISelectableButton, {
        "data-test-id": `trigger-selection-trigger-button-${illustrationName}`,
        selected: selected,
        block: true,
        disabled: disabled,
        className: "m-all-0 p-all-0",
        onClick: hasUpgradeModal ? openUpgradeModal : onClick,
        children: [/*#__PURE__*/_jsx(UIIllustration, {
          style: {
            flexShrink: 0
          },
          name: illustrationName,
          width: 80,
          height: 80
        }), /*#__PURE__*/_jsxs("div", {
          className: "text-left display-block flex-grow-1",
          children: [/*#__PURE__*/_jsx(H7, {
            className: "display-inline-block m-y-0",
            children: /*#__PURE__*/_jsx("b", {
              children: title
            })
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Small, {
            use: "help",
            children: info
          })]
        }), locked && /*#__PURE__*/_jsx(UILockBadge, {})]
      })
    })]
  });
};
export default TriggerTypeButton;